import React from 'react'
// libs
import styled from 'styled-components'
import { FieldArray } from 'redux-form'
// components
import { Collapse } from 'components/Modals/PlanItems/styles'
// view components
import Columns from './components/Columns'

const Wrapper = styled.div`
  border-top: 1px solid gray;
`

const CustomColumns: React.FC = () => {
  const [isExpanded, setExpanded] = React.useState(false)

  return (
    <Wrapper>
      <Collapse isCollapsed={!isExpanded} handleClick={() => setExpanded(!isExpanded)}>
        Custom Columns
      </Collapse>
      {isExpanded && <FieldArray<any> name='customColumns' component={Columns} />}
    </Wrapper>
  )
}

export default CustomColumns
